import PropTypes from 'prop-types';
import {useTheme} from 'react-jss';
import {connect} from 'react-redux';
import isUsingArtemisStyles from '../../v2/selectors/isUsingArtemisStyles';
import {getSettings, getSiteDataV2} from '../../v2/selectors/selectors';
import {isLightTheme} from '../../v2/style-helper/setContrastColorBasedOnBackground';
import bigQueryMetricRecorder from '../../v2/tracking/bigQueryMetricRecorder';
import Track from '../../v2/utils/tracking';
import SkipLink from '../Accessibility/SkipLink/SkipLink';
import SecurityCertificate from './SecurityCertificate/SecurityCertificate';
import useStyles from './PageHeader.styles';

export function PageHeader(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  const trackEvent = () => {
    try {
      bigQueryMetricRecorder('HeaderLogoClick');
    } catch (error) {
      Track.track(error);
    }
  };
  
  return (
    <header className={classes.header} data-test="PageHeader">
      <SkipLink />
      <div className={classes.container}>
        {props.isRTL && <SecurityCertificate isRTL />}
        <div className={classes.logoContainer} data-test="PageHeader__logo-container">
          <a
            className={classes.link}
            data-test="PageHeader__logoLink"
            id="logolink"
            href={props.homePageURL}
            title={props.logoAltText}
            onClick={trackEvent}
          >
            {props.isUsingArtemisStyles ? (
              <img
                id="logoImg"
                className={`${classes.logo} PageHeader__logo`}
                data-test="PageHeader__logo"
                src={theme.logo ? theme.logo.logoUri : null}
                alt=""
              />
            ) : (
              <p
                id="logoImg"
                className={`${classes.logo} PageHeader__logo--withImage`}
                data-test="PageHeader__logo"
              />
            )}
          </a>
        </div>
        {!props.isRTL && <SecurityCertificate />}
      </div>
    </header>
  );
}

const mapStateToProps = (state) => {
  const siteData = getSiteDataV2(state);
  const settings = getSettings(state);
  return {
    homePageURL: settings?.home_page_url || siteData.unsecureHomePageUrl,
    logoAltText: siteData.siteName,
    isRTL: window.direction === 'rtl',
    isUsingArtemisStyles: isUsingArtemisStyles(state),
  };
};

PageHeader.propTypes = {
  homePageURL: PropTypes.string.isRequired,
  logoAltText: PropTypes.string.isRequired,
  isRTL: PropTypes.bool,
  isUsingArtemisStyles: PropTypes.bool,
};

export default connect(
  mapStateToProps,
)(PageHeader);
